(() => {
  const mount = scope => {
    scope.querySelectorAll('[data-rnl-home-reviews]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const reviews = [...root.querySelectorAll('[data-rnl-home-review]')];
      const more = root.querySelector('[data-rnl-more-reviews]');
      const measure = article => {
        if (article.hidden || article.getBoundingClientRect().width === 0) return;
        const text = article.querySelector('[data-rnl-review-text]');
        const toggle = article.querySelector('[data-rnl-review-toggle]');
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        text.classList.remove('is-truncated');
        const line = parseFloat(getComputedStyle(text).lineHeight);
        const overflows = text.scrollHeight > line * 5 + 1;
        text.classList.toggle('is-truncated', overflows && !expanded);
        toggle.hidden = !overflows;
        toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
      };
      const measureAll = () => reviews.forEach(measure);
      reviews.forEach((article, index) => {
        const toggle = article.querySelector('[data-rnl-review-toggle]');
        if (index > 2) article.hidden = true;
        toggle.addEventListener('click', () => {
          toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
          measure(article);
        });
      });
      if (more && reviews.length > 3) {
        more.hidden = false;
        more.addEventListener('click', () => {
          const expanded = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? more.dataset.less : more.dataset.more;
          reviews.forEach((article, index) => { if (index > 2) article.hidden = !expanded; });
          measureAll();
        });
      }
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(measureAll);
        observer.observe(root);
        const unload = event => {
          if (!event.target.contains(root)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      } else window.addEventListener('resize', measureAll, {passive:true});
      measureAll();
      if (document.fonts) document.fonts.ready.then(measureAll);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
